$('.hotels-slider, .posts-slider').slick({
    rows: 0, // div wrapping issue in v1.8.1 fix
    dots: true,
    arrows: true,
    prevArrow: '<a href="#" class="slider-control control-prev gtm-event" title="Vorige" data-gtm-event="Hotels slider control: previous" rel="nofollow">&larr;</a>',
    nextArrow: '<a href="#" class="slider-control control-next gtm-event" title="Volgende" data-gtm-event="Hotels slider control: next" rel="nofollow">&rarr;</a>',
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 500,
    cssEase: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)',
    // centerMode: true,
    // focusOnSelect: true,
    customPaging: function (slick, index) {
        return '<a id="slick-dot-' + index + '" class="slick-dot" rel="nofollow"></a>';
    },
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2
            }
        },{
            breakpoint: 675,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});

// moving slider when item that is not active is clicked
$('.hotels-slider .slick-slide, .posts-slider .slick-slide').click( function(e) {
    if( !$(this).hasClass('slick-active') ) {
        e.preventDefault();
        var $slider = $(this).closest('.slick-slider');

        // check if slide is before or after active slides
        if( $(this).prevAll('.slick-active').length ) {
            // console.log('element comes after active');
            $slider.slick('slickNext');
        } else {
            // console.log('element comes before active');
            $slider.slick('slickPrev');
        }
    }
});
